export const cvFormation = [
        {id:1, date:2021, content: 'Développeur web et web mobile à l\'eni école informatique jusqu\'en mai 2020, Titre RNCP Niveau 5.'},
        {id:2, date:2020, content: 'Deux cours au CNAM pour la formation de développeur web, Réseaux et administration web avec Linux/Apache, Bases de données avec PostgreSQL.'},
        {id:3, date:2017, content: 'CAP Cuisine Saint Nazaire'},
        {id:4, date:2000, content: 'Technicien des réseaux informatiques, Titre pro, Grèce.'},
        {id:5, date:1997, content: 'Baccalauréat, Grèce.'}
];

export const cvExperiance = [
        {
                id:1, 
                date:'Janvier 2020', 
                content: 'Stage développeur web front-end KOALAD, Saint-Nazaire.'
        },
        {
                id:2, 
                date: '2016 - 2019', 
                content: 'Cuisinier, chef de partie dans plusieurs restaurants à Saint Nazaire et sur la presqu\'île.'
        },
        {
                id:3, 
                date: '2005 - 2015', 
                content: 'Apiculteur, agriculteur vendeur-producteur sur les marchés à Patras, (Péloponnèse, Grèce).'
        },
        {
                id:4, 
                date: '2004 - 2005', 
                content: 'Développeur Web front end freelance.'
        },
        {
                id:5, 
                date: '2002 - 2004', 
                content: 'Développeur Web front end à SatSpeed Patras, Grèce.'
        },
        {
                id:6, 
                date: '2000 - 2002', 
                content: 'Développeur Web front end à W3 Patras, Grèce.'
        },
        {
                id:7, 
                date: '1997 - 1999', 
                content: 'Employé dans le bâtiment.'
        }
];

export const cvOther = [
        {id:1, date:2021, content: 'Développeur web et web mobile à l\'eni école informatique à partir du 05/10/2020, Titre RNCP Niveau 3.'},
        {id:2, date:2020, content: 'Deux cours au CNAM pour la formation de développeur web, Réseaux et administration web avec Linux/Apache, Bases de données avec PostgreSQL.'},
        {id:3, date:2017, content: 'CAP Cuisine Saint Nazaire'},
        {id:4, date:2000, content: 'Technicien des réseaux informatiques, Titre pro, Grèce.'},
        {id:5, date:1997, content: 'Baccalauréat, Grèce.'}
];